import { Box, Button, Typography } from '@mui/material'
import { DateTimePicker } from 'components/ui/DatePicker'

type Props = {
  fromDate: Date
  toDate: Date
  changeFromDate: (newFromdate: Date) => void
  changeToDate: (newTodate: Date) => void
  setOpenDialog: (x: boolean) => void
}

// const ERR_MSG = '日付を正しく選択してください'
const BA_ERROR_MSG = '絞り込みの開始日時以降を選択ください'

function LogControlArea({ fromDate, toDate, changeFromDate, changeToDate, setOpenDialog }: Props) {
  const isBAError = fromDate?.getTime() > toDate?.getTime()
  return (
    <Box display="flex" mb={2}>
      <Box display="flex" alignItems="top" gap={1}>
        <DateTimePicker
          value={fromDate}
          format="yyyy/MM/dd HH:mm"
          onChange={(newValue) => {
            changeFromDate(newValue as Date)
          }}
          localeText={{
            okButtonLabel: '決定',
          }}
          testid="start-date-time-picker"
        />
        <Typography variant="body1" sx={{ mt: 1, whiteSpace: 'nowrap' }}>
          から
        </Typography>
        <DateTimePicker
          value={toDate}
          format="yyyy/MM/dd HH:mm"
          onChange={(newValue) => {
            changeToDate(newValue as Date)
          }}
          errMsg={isBAError ? BA_ERROR_MSG : undefined}
          testid="end-date-time-picker"
          localeText={{
            okButtonLabel: '決定',
          }}
        />
        <Box sx={{ mt: 0.3 }}>
          <Button
            onClick={() => {
              setOpenDialog(true)
            }}
            variant="outlined"
            color="primary"
            data-testid="usage-log-change-conditions-button"
          >
            条件変更
          </Button>
        </Box>
      </Box>
      {/* スコープアウトのため一旦コメントアウト
      <Box>
        <LogCsvDownloadButton/>
      </Box> */}
    </Box>
  )
}

export default LogControlArea
